var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerticalArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 32,
    viewBox: "0 0 10 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#01AE8F",
    d: "M31 5.008c-.27 0-30.716-.006-31-.016",
    transform: "translate(-32 -662) translate(0 48) translate(12 215) translate(20 301) translate(0 98) rotate(90 5 5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01AE8F",
    d: "M28.512 1.222l3.426 8.4c.209.512-.037 1.095-.548 1.304-.12.049-.248.074-.378.074h-7c-.552 0-1-.448-1-1 0-.135.027-.268.08-.392l3.574-8.4C26.882.7 27.47.465 27.978.68c.243.103.435.298.534.542z",
    transform: "translate(-32 -662) translate(0 48) translate(12 215) translate(20 301) translate(0 98) rotate(90 5 5) rotate(90 27.5 5)"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalArrow);
export default __webpack_public_path__ + "static/media/vertical-arrow.a38e81f6.svg";
export { ForwardRef as ReactComponent };